import { Box } from '@mui/material'
import { useStore } from '@priolo/jon'
import SelectorMetaColsH from 'components/controls/select/SelectorMetaColsH'
import SelectorMetaFeature from 'components/controls/select/SelectorMetaFeature'
import SelectorMetaGroup from 'components/controls/select/SelectorMetaGroup'
import SelectorMetaService from 'components/controls/select/SelectorMetaService'
import { FunctionComponent, useMemo } from 'react'
import { isDefaultColProps } from 'stores/metadata/utils/utils'
import querySo from 'stores/route/query'
import { URL_PAR } from 'stores/route/utils/types'
import { MetaColsAll, MetaColsDefault } from '../../../stores/metadata/types'



interface Props {
	hideSelectorCols?: boolean
	sx?: any
}

const MetaFilterHeader: FunctionComponent<Props> = ({
	hideSelectorCols,
	sx,
}) => {

	// STORE
	const querySa = useStore(querySo)

	// HOOKs

	// HANDLERs
	const handleGroupChange = (group: string) => {
		querySo.setSearchUrl([URL_PAR.META_GROUP, group])
	}
	const handleServiceChange = (service: string) => {
		querySo.setSearchUrl([URL_PAR.META_SERVICE, service])
	}
	const handlePropChange = (prop: string) => {
		querySo.setSearchUrl([URL_PAR.META_FEATURE, prop])
	}
	const handleColNamesChanged = (colNames: string[]) => {
		let colNamesUrl = null
		// se non sono le colonne di default ...
		if (!!colNames && colNames.length > 0 && !isDefaultColProps(colNames)) {
			// metto nello stesso odine dell'array MetaColsAll
			colNamesUrl = MetaColsAll
				.reduce((acc, p1) => acc.concat(colNames.includes(p1.name) ? p1.name : []), [])
				.join("-")
		}
		querySo.setSearchUrl([URL_PAR.META_COLS, colNamesUrl])
	}

	// RENDER
	const [colNamesSelected, group, service, prop] = useMemo(() => {
		const [colsUrl, ...other] = querySo.getSearchUrl([URL_PAR.META_COLS, URL_PAR.META_GROUP, URL_PAR.META_SERVICE, URL_PAR.META_FEATURE])
		const colNamesSelected = colsUrl ? colsUrl.split("-") : MetaColsDefault.map(mc => mc.name)
		return [colNamesSelected, ...other]
	}, [querySa.queryUrl])

	return (
		<Box sx={[{ display: "flex", alignItems: "center", gap: "10px" }, sx]}>
			<SelectorMetaService
				service={service}
				onChange={handleServiceChange}
			/>
			<SelectorMetaGroup
				group={group}
				onChange={handleGroupChange}
			/>
			<SelectorMetaFeature
				feature={prop}
				onChange={handlePropChange}
			/>
			{!hideSelectorCols && <SelectorMetaColsH
				colNames={colNamesSelected}
				onChange={handleColNamesChanged}
			/>}
		</Box >
	)
}

export default MetaFilterHeader

